import { render, staticRenderFns } from "./Vendors.vue?vue&type=template&id=0a70b132&scoped=true"
import script from "./Vendors.vue?vue&type=script&lang=js"
export * from "./Vendors.vue?vue&type=script&lang=js"
import style0 from "./Vendors.vue?vue&type=style&index=0&id=0a70b132&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a70b132",
  null
  
)

export default component.exports